//竞价结果的api
import request from "../utils/request";

export function executeBillQuery(data){
    // console.log('登录')
    // console.log(data)
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.ExecuteBillQuery.common.kdsvc',
        data:data
    })
}

export function billView(data){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.View.common.kdsvc',
        data:data
    })
}


export function save(data){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.Save.common.kdsvc',
        data:data
    })
}

export function submit(data){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.Submit.common.kdsvc',
        data:data
    })
}
